import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../../lib/api";
import { PhoneCall, Check, X, Trash2, UserPlus, ShieldCheck } from "lucide-react";

export default function Customers() {
  const [users, setUsers] = useState([]);
  const [showStaff, setShowStaff] = useState(false);

  const load = () => api.get("/customers").then((r) => setUsers(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => { try { await api.patch(`/customers/${id}/status`, { status }); toast.success(status === "approved" ? "Müşteri onaylandı" : "Güncellendi"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const del = async (id) => { if (!window.confirm("Silinsin mi?")) return; try { await api.delete(`/customers/${id}`); load(); } catch (e) { toast.error(errMsg(e)); } };

  const customers = users.filter((u) => u.role === "customer");
  const waiters = users.filter((u) => u.role === "waiter");
  const pending = customers.filter((u) => u.status === "pending");

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <div>
          <h1 className="font-serif text-3xl sm:text-4xl text-white">Müşteri & Personel Onayı</h1>
          <p className="text-zinc-400 text-sm mt-1">Telefonla kaydolan müşterileri arayıp onaylayın (sahte sipariş engelleme)</p>
        </div>
        <button onClick={() => setShowStaff(true)} className="btn-gold px-5 py-2.5 rounded-xl flex items-center gap-2" data-testid="add-staff-btn"><UserPlus size={18} /> Garson Ekle</button>
      </div>

      {pending.length > 0 && (
        <div className="card-lux p-4 mb-6 border border-amber-500/30 bg-amber-950/20" data-testid="pending-banner">
          <span className="text-amber-200 text-sm flex items-center gap-2"><PhoneCall size={16} /> {pending.length} müşteri onay bekliyor. Arayıp doğruladıktan sonra onaylayın.</span>
        </div>
      )}

      <h2 className="font-serif text-xl text-white mb-3">Müşteriler ({customers.length})</h2>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4 mb-8">
        {customers.map((u) => (
          <div key={u.id} className="card-lux p-4" data-testid={`customer-${u.id}`}>
            <div className="flex items-center justify-between">
              <div><div className="font-serif text-lg text-white">{u.name}</div><div className="font-mono text-sm text-[#FFE599]">{u.phone}</div></div>
              <span className={`text-[10px] font-mono px-2.5 py-1 rounded-full border ${u.status === "approved" ? "text-emerald-400 bg-emerald-950/40 border-emerald-500/30" : u.status === "rejected" ? "text-rose-400 bg-rose-950/40 border-rose-500/30" : "text-amber-400 bg-amber-950/40 border-amber-500/30"}`}>
                {u.status === "approved" ? "Onaylı" : u.status === "rejected" ? "Reddedildi" : "Bekliyor"}
              </span>
            </div>
            <div className="text-xs text-zinc-500 mt-1">{u.email}</div>
            <div className="flex gap-2 mt-4">
              {u.status !== "approved" && <button onClick={() => setStatus(u.id, "approved")} className="btn-gold flex-1 py-2 rounded-lg text-sm flex items-center justify-center gap-1.5" data-testid={`approve-${u.id}`}><PhoneCall size={14} /> Ara & Onayla</button>}
              {u.status === "approved" && <button onClick={() => setStatus(u.id, "pending")} className="btn-outline flex-1 py-2 rounded-lg text-sm flex items-center justify-center gap-1.5" data-testid={`revoke-${u.id}`}><X size={14} /> Onayı Kaldır</button>}
              <button onClick={() => del(u.id)} className="text-rose-400 hover:bg-rose-500/10 h-9 w-9 rounded-lg flex items-center justify-center" data-testid={`del-cust-${u.id}`}><Trash2 size={15} /></button>
            </div>
          </div>
        ))}
        {customers.length === 0 && <p className="text-zinc-600 text-sm">Henüz müşteri yok</p>}
      </div>

      <h2 className="font-serif text-xl text-white mb-3">Garsonlar ({waiters.length})</h2>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {waiters.map((u) => (
          <div key={u.id} className="card-lux p-4 flex items-center justify-between" data-testid={`waiter-${u.id}`}>
            <div className="flex items-center gap-3"><ShieldCheck className="text-[#D4AF37]" size={20} /><div><div className="text-white">{u.name}</div><div className="text-xs text-zinc-500">{u.email}</div></div></div>
            <button onClick={() => del(u.id)} className="text-rose-400 hover:bg-rose-500/10 h-9 w-9 rounded-lg flex items-center justify-center" data-testid={`del-waiter-${u.id}`}><Trash2 size={15} /></button>
          </div>
        ))}
      </div>

      {showStaff && <StaffModal onClose={() => setShowStaff(false)} onDone={() => { setShowStaff(false); load(); }} />}
    </div>
  );
}

function StaffModal({ onClose, onDone }) {
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!f.name || !f.email || !f.password) return toast.error("Tüm alanları doldurun");
    setBusy(true);
    try { await api.post("/auth/staff", f); toast.success("Garson eklendi"); onDone(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" data-testid="staff-modal">
      <div className="card-lux w-full max-w-md scale-in">
        <div className="px-5 py-4 border-b border-[#D4AF37]/20 flex items-center justify-between">
          <h2 className="font-serif text-2xl gold-text">Garson Ekle</h2>
          <button onClick={onClose} className="text-zinc-400 hover:text-white"><X size={24} /></button>
        </div>
        <div className="p-5 space-y-4">
          <input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Ad Soyad" className="lux-input" data-testid="staff-name" />
          <input value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="E-posta" className="lux-input" data-testid="staff-email" />
          <input type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="Şifre" className="lux-input" data-testid="staff-password" />
          <button onClick={save} disabled={busy} className="btn-gold w-full py-3 rounded-xl" data-testid="staff-save">{busy ? "..." : "Ekle"}</button>
        </div>
      </div>
    </div>
  );
}
